import { render, staticRenderFns } from "./category-tile-create.vue?vue&type=template&id=235f1716&scoped=true"
import script from "./category-tile-create.vue?vue&type=script&lang=js"
export * from "./category-tile-create.vue?vue&type=script&lang=js"
import style0 from "./category-tile-create.vue?vue&type=style&index=0&id=235f1716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f1716",
  null
  
)

export default component.exports